const styles = {
  match: {
    cursor: 'pointer',
  },
  dialogbody: {
    // padding: '0 30px',
  },
  closerow: {
    textAlign: 'right',
    height: '5px',
  },
  close: {
    cursor: 'pointer',
  },
  img_close: {
    width: '30px',
    '&:hover': {
      width: '22px',
      transition: 'all 0.15s ease',
    },
  },
  intro: {
    textAlign: 'center',
    marginBottom: '10px',
  },
  introtitle: {
    fontSize: '22px',
    fontFamily: 'League Gothic',
    fontWeight: '400',
    textTransform: 'uppercase',
    color: '#7F1431',
  },
  bold: {
    fontSize: '45px',
  },
  introdesc: {
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  teamsheader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    marginTop: '10px',
    marginBottom: '10px',
  },
  flag: {
    cursor: 'pointer',
  },
  img: {
    height: '65px',
    width: '65px',
  },
  team: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '211px',
  },
  teamname: {
    fontSize: '28px',
    fontWeight: '400',
    // margin: '20px 0 0',
    fontFamily: 'League Gothic',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  chances: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '14px',
  },
  ball_left: {
    height: '14px',
    width: '14px',
    borderRadius: '20px',
    backgroundColor: '#62AD1D',
    marginRight: '7px',
  },
  ball_right: {
    height: '14px',
    width: '14px',
    borderRadius: '20px',
    backgroundColor: '#F9981D',
    marginLeft: '7px',
  },
  gaugecontainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
  teamStats: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    justifyContent: 'center',
    marginTop: '15px',
    fontSize: '14px',
  },
  dialogdesc: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    textAlign: 'center',
    margin: '10px 0 0 0',
  },
  dialogControls: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    margin: '20px 0',
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginBottom: '10px',
    color: '#62AD1D',
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
    color: '#F9981D',

  },
  legend: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    margin: '0 10px',
    minWidth: '88px',
  },
  ball: {
    width: '14px',
    height: '14px',
    border: '1px solid lightgray',
    marginRight: '7px',
    borderRadius: '12px',
  },
  ball1: {
    composes: ['$ball'],
    '&:hover': {
      backgroundColor: '#62AD1D',
    },
  },
  ball2: {
    composes: ['$ball'],
    '&:hover': {
      backgroundColor: '#F9981D',
    },
  },
  button1: {
    cursor: 'pointer',
    padding: '5px 10px',
    // borderRadius: '20px',
    border: '1px solid #62AD1D',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    maxWidth: '170px',
    margin: '0 auto',
    // '&:hover': {
    //   border: '1px solid #62AD1D',
    //   color: '#62AD1D',
    // },
  },
  button2: {
    cursor: 'pointer',
    padding: '5px 10px',
    // borderRadius: '20px',
    border: '1px solid #F9981D',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    maxWidth: '170px',
    margin: '0 auto',
    // '&:hover': {
    //   border: '1px solid #F9981D',
    //   color: '#F9981D',
    // },
  },
  grow: {
    flexGrow: '0.12',
  },
  spacer: {
    height: '102px',
  },
  victory: {
    marginBottom: '6px',
  },
  recent: {
    margin: '20px 0 10px',
  },

  smalltext: {
    fontSize: '12px',
  },
  separator: {
    height: '15px',
  },
  luidialogbody: {
    padding: '5px 20px',
  },
  bad: {
    color: 'crimson',
    textDecoration: 'line-through',
    textDecorationStyle: 'double',
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    padding: '5px',
    backgroundColor: '#FFFFFF',
    height: '90%',
    overflowY: 'auto',
    maxHeight: '686px',
  },
};

export default styles;
